import React from 'react';
import ButtonLink from '../components/Button';

const Home = () => {
  
  return (
    <div className="page">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="inte-h1">INTEGRALIS</h1>
          <h2>University of Helsinki</h2>

          <p className="hero-description">
            Integralis is the student organization for all international students at Kumpula campus of University of Helsinki
            and the main student organisation for the Bachelor's Programme in Science students.
            We bring together students from various scientific disciplines and create a community for learning, networking, and fun.
          </p>
        </div>
      </div>

      <section className="info-section">
        <div className="container">
          <div className="info-grid">

            <div className="info-card">
              <h3>Join us</h3>
              <p>
                Become an Integralis member through Kide.app for 3€. The membership is
                strongly recommended for all Bachelor's Programme in Science
                students and other international students at Kumpula.
              </p>

              <p>
                <ButtonLink href="https://kide.app/memberships/fcd12525-fe79-4225-b6ca-07100918e5e2">
                  Join via Kide.app
                </ButtonLink>
              </p>

              <p>
                We use telegram for our communications.
                You can join our chats through the Telegram link below.
                Make sure to also follow us on Instagram to see updates on upcoming events!
              </p>

              <p>
                <ButtonLink href="https://t.me/Integralishub">
                  Integralis Telegram Hub
                </ButtonLink>
              </p>
            </div>

            <div className="info-card">
              <h3>Do you want to find out what we discuss at our board meetings?</h3>
              <p>
                <ButtonLink href="https://helsinkifi.sharepoint.com/:f:/s/Integralis/IgDZ81YIxjiBQZeGgP5O4JMyAXFcPjDccKShokuaFsVnDts?e=UZBT92">
                  Board meeting protocols
                </ButtonLink>
              </p>

              <h3>Do you have feedback?</h3>
              <p>
                
                Whether you have an idea for an event, a concern, 
                or a suggestion on how Integralis can better support you, feedback is always welcome.
              </p>
              <p>You can submit feedback anonymously.</p>
              <p>
                <ButtonLink href="https://forms.cloud.microsoft/e/FpYzQEsjR7">
                  Give feedback (Microsoft forms)
                </ButtonLink>
              </p>
              

            </div>

            <div className="info-card">
              <h3>Find out more about our upcoming events</h3>
              <p>
                <ButtonLink href="/events">
                  Events
                </ButtonLink>
              </p>
              <h3>Find our period II course recommendations</h3>
              <p>
                <ButtonLink href="https://cdn.jsdelivr.net/gh/integralis-ry/site_binaries@latest/documents/2026_Study_Guide_period_2.pdf">
                  Period II study guide (pdf)
                </ButtonLink>
              </p>
            </div>
            
            
          </div>

        </div>




      </section>
    </div>
  );
};

export default Home;
